import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';

import { RefinanceGoal } from '../enums/RefinanceGoal';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromPreview } from '../types/HydrateFromPreview';
import { VehicleIdentifiers } from '../types/VehicleIdentifiers';
import { isValidVin } from './isValidVin';

export const toApplyStateFromPreview = async (
  preview: HydrateFromPreview,
  findVehicleByVin: (vin: string) => Promise<VehicleIdentifiers | null>,
): Promise<Partial<ApplyState>> => {
  const applicationType = isInEnum(preview.applicationType, ApplicationType)
    ? preview.applicationType
    : ApplicationType.REFINANCE;

  const refinanceGoal: RefinanceGoal | null =
    applicationType === ApplicationType.REFINANCE
      ? RefinanceGoal.LOWER_PAYMENT
      : null;

  const vin = isValidVin(preview.vin) ? preview.vin : null;

  const searchVehicle: SearchVehicle | null = vin ? SearchVehicle.BY_VIN : null;

  const vehicle = vin ? await findVehicleByVin(vin) : null;

  const make = vehicle?.make || null;
  const model = vehicle?.model || null;
  const trim = vehicle?.trim || null;
  const year = vehicle?.year || null;

  return {
    applicationType,
    make,
    model,
    refinanceGoal,
    searchVehicle,
    trim,
    vin,
    year,
  };
};
